import { getUuid, isProd, getBrowserName } from "../tools.js"
import { formatDate } from "../dateTime.js"
import { firebaseInit } from "@/utils/analytic/firebaseWrapper.js"
import { getUseSource } from "@/api/net/config.js"
import globalConfig from "@/config/config.js"

let saInstance = null;

export const firebaseUtils = {
  getAnonymousID: async () => {
    if (import.meta.env.SSR) return '';
    const sa = await getSA();
    return await sa?.quick("getAnonymousID") ?? '';
  },
};

export async function getSA() {
  if (import.meta.env.SSR) return null;
  if (!saInstance) {
    await import("./abtest.esm.min.js")
    const module = await import("sa-sdk-javascript");
    saInstance = module.default || module;

    const env = import.meta.env.VITE_APPNAME ?? "Mureka";
    const url = `https://sa.yinhe.top/sa?project=${isProd() ? "mureka" : "mureka-test"}&token=Ehp5cUw99q6lSxOm4`;
    const urlCn = `https://sa.yinhe.top/sa?project=${isProd() ? "murekacn" : "murekacn-test"}&token=Ehp5cUw77q6lSxOm4`;

    saInstance.init({
      server_url: env === "Mureka" ? url : urlCn,
      is_track_single_page: true,
      heatmap: {
        clickmap: "not_collect",
        scroll_notice_map: "default",
      },
      abtest: {
        enable_auto_track: true,
      },
    });

    const gaInfo = document.cookie?.match(/_ga=(.+?);/)?.[1] ?? "";
    saInstance.registerPage({
      platform: globalConfig.platform,
      firebase_id: gaInfo ?? "",
      $browser: getBrowserName(),
    });

    saInstance.quick("autoTrack");

    // 修正 SensorsABTest 挂载方式，确保 abtest 实例有 fastFetchABTest 方法
    const abtestInstance = saInstance.use("SensorsABTest", {
      url: globalConfig.abtestUrl,
      multilink: false,
    });
    firebaseUtils.abtest = abtestInstance;
  }
  return saInstance;
}

export default {
  install: (app, options) => {
    if (import.meta.env.SSR) return;

    let page;
    let referrer = document.referrer;
    const env = import.meta.env.VITE_APPNAME ?? "Mureka";

    const firebaseConfig = {
      apiKey: "AIzaSyBcGnuedT7WsyKn05iZphkjIjsAJt-xkz0",
      authDomain: "mureka-35a18.firebaseapp.com",
      projectId: "mureka-35a18",
      storageBucket: "mureka-35a18.appspot.com",
      messagingSenderId: "247728744599",
      appId: "1:247728744599:web:18ebbaca5995b7ae8ba1d2",
      measurementId: "G-FY4GZWS3Q4",
    };

    firebaseInit(firebaseConfig);

    const pointInitFunc = function (_page) {
      page = _page;
      referrer = document.referrer;
    };

    const getBdVid = () => {
      const adSourceStorage = window.sessionStorage.getItem("ad_source");
      if (!adSourceStorage) return null;
      const { bd_vid } = JSON.parse(adSourceStorage);
      return bd_vid || null;
    };

    const assignParams = (params, eventType) => {
      const useSource = getUseSource();
      return Object.assign(params, {
        referrer,
        traceid: getUuid(),
        date: formatDate(new Date(), "YYYY-MM-DD hh:mm:ss:c"),
        event: eventType ?? "custom",
        source_type: useSource ? useSource.split("_")[0] : "",
        ad_source: useSource ?? "",
        ad_bd_vid: getBdVid() ?? "",
      });
    };

    const safeSACall = async (callback) => {
      if (import.meta.env.SSR) return;
      const sa = await getSA();
      if (sa) {
        callback(sa);
      }
    };

    const logViewEvent = async function (eventName, params = {}) {
      safeSACall((sa) => {
        const log_type = "show";
        sa.track(`${eventName}_${log_type}`, assignParams(params, log_type));
        console.log("埋点🍎🍎🍎🍎🍎🍎🍎", `${eventName}_${log_type}`, assignParams(params, log_type))
      });
    };

    const logClickEvent = async function (eventName, params = {}) {
      safeSACall((sa) => {
        const log_type = "click";
        if (params?.content_id != undefined) {
          params.content_id = params.content_id.toString();
        }
        sa.track(`${eventName}_${log_type}`, assignParams(params, log_type));
        console.log("埋点🍎🍎🍎🍎🍎🍎🍎", `${eventName}_${log_type}`, assignParams(params, log_type))
      });
    };

    const logCustomEvent = async function (eventName, params = {}, eventType) {
      safeSACall((sa) => {
        if (params?.content_id != undefined) {
          params.content_id = params.content_id.toString();
        }
        const event = `${eventName}${eventType ? "_" + eventType : ""}`;
        sa.track(event, assignParams(params, eventType));
        console.log("埋点🍎🍎🍎🍎🍎🍎🍎", event, assignParams(params, eventType))
      });
    };

    const logLoginEvent = async function (userId) {
      safeSACall((sa) => {
        if (userId) {
          const validUserId = String(userId).trim();
          if (validUserId) {
            try {
              sa.login(validUserId);
            } catch (error) {
              console.warn("神策登录ID设置失败:", error);
            }
          }
        }
      });
    };

    app.config.globalProperties.logPageMounted = async function (page, params = {}) {
      if (params?.content_id != undefined) {
        params.content_id = params.content_id.toString();
      }
      pointInitFunc(page, params);
      await logViewEvent(page, params);
    };

    app.config.globalProperties.logViewEvent = logViewEvent;
    app.config.globalProperties.logClickEvent = logClickEvent;
    app.config.globalProperties.logCustomEvent = logCustomEvent;

    Object.assign(firebaseUtils, {
      logViewEvent,
      logClickEvent,
      logCustomEvent,
      logLoginEvent,
      abtest: '', // 如需使用 saInstance.use() 可放开
    });
  },
};